import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppFilter } from 'src/modules/shared';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

interface IViewDetailsModalContext {
  title: String;
  details: any;
}
@Component({
  selector: 'app-view-details-modal',
  templateUrl: './view-details-modal.component.html',
  styleUrls: ['./view-details-modal.component.scss'],
})
export class ViewDetailsModalComponent {
  baseUrl = environment.API_SERVER;

  pending: boolean;
  success: any;
  error: any;
  filter: AppFilter = new AppFilter();

  data;
  currencyId;
  documents;
  secureDocumentUrl;

  constructor(
    public modal: SuiModal<IViewDetailsModalContext, void, void>,
    private sanitizer: DomSanitizer,
    private walletSvc: EwalletService
  ) {
    this.data = modal.context.details;
    console.log(this.data, 'extra');
    this.currencyId = localStorage.getItem('selectedCurrencyId');
  }

  ngOnInit() {
    if (this.modal.context.title == 'View Withdrawal Request Details') {
      this.getDocumentsById();
    }
  }
  dataToJSON(data: any) {
    try {
      const jsonData = JSON.parse(data);
      return jsonData;
    } catch (error) {
      return null; // or handle the error in another way
    }
  }

  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  viewDocument(documentData: any) {
    this.secureDocumentUrl = this.sanitizer.bypassSecurityTrustUrl(
      `${this.baseUrl}/finance/public/media/?media=${documentData?.documentPath}`
    );
    // window.open(`${this.baseUrl}/public/media/?media=${documentPath}`, '_blank');
  }

  getDocumentsById() {
    this.pending = true;
    this.walletSvc
      .getWithdrawalRequestDocumentsById({
        withdrawalRequestId: this.data.withdrawalRequestId,
        params: this.filter,
      })
      .subscribe({
        next: (res: any) => {
          console.log(res);
          this.pending = false;
          this.documents = res;
        },
        error: (error: any) => {
          console.log(error);
          this.pending = false;
        },
      });
  }

  getLastWord(str: string) {
    let arr;
    if (str.includes('_')) {
      arr = str.split('_');
    } else {
      arr = str.split(' ');
    }
    let lastWord = arr[arr.length - 1];
    return lastWord.toLowerCase() == 'funding' ? 'Deposit' : lastWord;
  }
}

export class ViewDetailsModal extends ComponentModalConfig<
  IViewDetailsModalContext,
  void,
  void
> {
  constructor(title: String, details: any, size: ModalSize = ModalSize.Mini) {
    super(ViewDetailsModalComponent, { title: title, details: details });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
